import ModalContactSupport from './ModalContactSupport-redux';

export default ModalContactSupport;
